import type { RouteRecordRaw } from 'vue-router'

import { useDataConnectorsAccess } from './composables/useDataConnectorsAccess'
import { registerDataConnectorMessages } from './i18n'

import type { SettingsNavEntry } from '@/features/workspace-settings'
import { useLocaleStore } from '@/shared/i18n'

export interface DataConnectorSettingsRegistrar {
  registerNav: (entry: SettingsNavEntry) => void
  registerRoutes: (records: RouteRecordRaw[]) => void
}

export const DATA_CONNECTORS_SETTINGS_NAV_KEY = 'workspace.dataConnectors'

export const dataConnectorSettingsRoutes: RouteRecordRaw[] = [
  {
    path: 'workspace/data-connectors',
    name: 'SettingsDataConnectors',
    component: () => import('./components/DataConnectorsPage.vue'),
    props: { embedded: true },
    meta: {
      permission: 'ad_metric_integrator',
      titleKey: 'dataConnectors.page.title',
      subtitleKey: 'dataConnectors.page.subtitle',
      navKey: DATA_CONNECTORS_SETTINGS_NAV_KEY,
    },
    beforeEnter: () => registerDataConnectorMessages(useLocaleStore().locale),
  },
]

export function installConnectorsPane(reg: DataConnectorSettingsRegistrar): void {
  reg.registerRoutes(dataConnectorSettingsRoutes)
  const access = useDataConnectorsAccess()
  reg.registerNav({
    key: DATA_CONNECTORS_SETTINGS_NAV_KEY,
    labelKey: 'dataConnectors.nav.label',
    icon: 'gear',
    group: 'workspace',
    order: 80,
    routeName: 'SettingsDataConnectors',
    visible: () => access.canView.value,
  })
}
